import i18n from '../i18n';
import { toast } from '../store/toastStore';
import { workLogNoticeKeys } from './workLogNoticeKeys';

/** D-266 - show the notices of a saved work log (if any) as long-lived warning toasts - the log was saved. */
export function toastWorkLogNotices(res: unknown): void {
  for (const k of workLogNoticeKeys(res)) toast('warning', i18n.t(k));
}
